module.exports = __webpack_public_path__ + "static/media/ic_02_datatraffic.c644fe88.svg";